App = App || {};

App.RedeemPoints = (function ($, Vue) {
	"use strict";

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("redeem-points-app");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		new Vue({
			el: rootElement,
			data: {
				memberId: String(rootElement.getAttribute("data-member-id") || ""),
				items: [],
				shippingOptions: [],
				countries: [],
				shippingLoading: false,
				appLoading: true,
				form: {
					item: null,
					quantity: 1,
					csrOverride: false
				},
				order: {
					orderLines: [],
					shippingOption: {},
					shippingAddress: {}
				},
				tableFields: [
					{ key: "item.sonaItemNo", label: "Model #", sortable: false },
					{ key: "item.description", label: "Description", sortable: false },
					{ key: "unitPrice", label: "Points", sortable: false },
					{ key: "quantity", label: "Qty", sortable: false },
					{ key: "extendedPrice", label: "Line Total", sortable: false },
					{ key: "actions", label: "", sortable: false }
				],
				isAddingItem: false,
				isSubmitting: false,
				alertMessages: [],
				alertClass: "alert alert-warning",
				commentSaveTimerId: null,
				activeCommentSaveRequest: null
			},
			computed: {
				selectedItemPoints: function () {
					return this.getItemPoints(this.form.item);
				},
				currentCountry: function () {
					return this.countries.find(c => c.code === this.order?.shippingAddress?.countryCode);
				},
				currentRegions: function () {
					return this.currentCountry?.regions || [];
				},
				itemsByItemNo: function () {
					return (this.items || []).slice().sort((a, b) =>
                        String(a.sonaItemNo || "").localeCompare(String(b.sonaItemNo || ""), undefined, { sensitivity: "base" })
					);
				},
				itemsByDescription: function () {
					return (this.items || []).slice().sort((a, b) =>
						String(a.description || "").localeCompare(String(b.description || ""), undefined, { sensitivity: "base" })
					);
				},
				shippingAddressLines() {
					const address = this.order?.shippingAddress || {};
					const line1 = [address.street].filter(Boolean).join(" ");
					const line2 = [address.city, address.regionCode, address.postalCode].filter(Boolean).join(", ");
					const line3 = address.countryCode || "";
					return [line1, line2, line3].filter(Boolean);
				}
			},
			methods: {
				getItemPoints: function (item) {
					if (!item || !Array.isArray(item.prices))
						return 0;

					const priceClass = this.order.member?.priceClass || "Standard";
					var purchasePrice = item.prices.find(price => price.aspect === "Purchased" && price.class === priceClass);

					if (!purchasePrice)
						return 0;

					return Number(purchasePrice.value) || 0;
				},

				loadOrder: function () {
					return $.ajax({
						url: `/api/redeem/order/${this.memberId}`,
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response && response.success) {
							this.order = response.data;
							this.loadShippingOptions(this.order?.shippingAddress?.countryCode);
						} else {
							this.alertMessages.push(response?.message || "Unable to load order.");
						}
					}).fail((jq, s, e) => console.error("AJAX error loading order:", s, e));
				},

				addOrderLine: function () {
					if (!this.form.item || this.isAddingItem || this.isSubmitting)
						return;

					this.isAddingItem = true;
					this.alertMessages = [];
					this.alertClass = "alert alert-success";

					$.ajax({
						url: "/api/redeem/lines",
						method: "POST",
						contentType: "application/json",
						dataType: "json",
						data: JSON.stringify({
							memberId: this.memberId,
							itemId: this.form.item.id,
							quantity: Math.max(1, Number(this.form.quantity) || 1),
							csrOverride: this.form.csrOverride || false
						})
					}).done(response => {
						if (response && response.success) {
							this.order = response.data.order;
							this.form.item = null;
							this.form.quantity = 1;
							this.applyAlertFromMessages(response, true);
						} else {
							this.alertMessages = [response?.message || "Unable to add item."];
							this.alertClass = this.classForSeverity("Error");
						}
					}).fail((jq, s, e) => {
						this.alertMessages = ["Unable to add item."];
						this.alertClass = this.classForSeverity("Error");
					}).always(() => {
						this.isAddingItem = false;
					});
				},

				removeOrderLine: function (id) {
					if (!id)
						return;

					this.alertMessages = [];
					this.alertClass = "alert alert-success";

					$.ajax({
						url: "/api/redeem/lines",
						method: "DELETE",
						dataType: "json",
						contentType: "application/json",
						data: JSON.stringify({
							memberId: this.memberId,
							itemId: id
						})
					}).done(response => {
						if (response && response.success) {
							this.order = response.data.order;
							this.alertMessages = ((response && response.data && response.data.messages) || [])
								.map(function (e) {
									return e.message;
								})
								.filter(Boolean);
						} else {
							this.alertMessages.push(response?.message || "Unable to remove line.");
						}
					}).fail((jq, s, e) => console.error("AJAX error removing line:", s, e));
				},

				submit: function () {
					if (!this.order.orderLines.length || this.isAddingItem || this.isSubmitting)
						return;

					this.isSubmitting = true;
					this.alertMessages = [];
					this.alertClass = "alert alert-success";

					$.ajax({
						url: `/api/redeem/submit/${this.memberId}`,
						method: "POST",
						contentType: "application/json",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 30000
					}).done((response) => {
						if (response && response.success === true) {
							this.order = response.data.order;
							this.resetFormForNext();
							this.applyAlertFromMessages(response, true);
						} else {
							this.applyAlertFromMessages(response, false);
							if (!this.alertMessages.length) {
								this.alertMessages = [response?.message || "Submission failed"];
								this.alertClass = this.classForSeverity("Error");
							}
						}
					}).fail((jq, status, err) => {
						this.alertMessages = ["Submission failed"];
						this.alertClass = this.classForSeverity("Error");
					}).always(() => {
						this.isSubmitting = false;
						this.$nextTick(() => {
							if (this.$refs.topAlert && this.$refs.topAlert.focus) this.$refs.topAlert.focus({ preventScroll: true });
						});
					});
				},

				resetFormForNext: function () {
					this.form.serialNumber = "";
					this.form.comment = "";
				},

				loadItems: function () {
					return $.ajax({
						url: "/api/redeem/items",
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response && response.success) {
							this.items = response.data;
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading items:", status, err);
					});
				},

				loadShippingOptions(countryCode) {
					if (!countryCode) {
						this.shippingOptions = [];
						return;
					}
					this.shippingLoading = true;

					return $.ajax({
						url: `/api/lookups/shipping-options/${countryCode}`,
						method: "GET",
						dataType: "json"
					})
						.done((response) => {
							if (response && response.success) {
								this.shippingOptions = response.data || [];
								if (this.shippingOptions.length === 0) {
									this.order.shippingOption = {};
								}
							} else {
								this.shippingOptions = [];
								this.order.shippingOption = {};
							}
						})
						.always(() => { this.shippingLoading = false; })
						.fail((jq, s, e) => console.error("AJAX error loading shipping options:", s, e));
				},

				setShippingOption(event) {
					var payload = {
						memberId: this.memberId,
						name: this.order.shippingOption.name,
						description: this.order.shippingOption.description,
						points: this.order.shippingOption.points
					}

					$.ajax({
						url: "/api/redeem/shipping-options",
						method: "POST",
						contentType: "application/json",
						dataType: "json",
						data: JSON.stringify(payload)
					})
						.done((response) => {
							if (response && response.success) {
								this.order = response.data?.order || response.data;

							} else {
								this.alertMessages.push("Unable to set shipping");
								this.alertClass = this.classForSeverity("Error");
							}
						})
						.fail((jq, s, e) => console.error("AJAX error setting shipping:", s, e));
				},

				saveShippingAddress() {
					this.order.shippingAddress.memberId = this.memberId;
					$.ajax({
						url: "/api/redeem/shipping-address",
						method: "POST",
						contentType: "application/json",
						dataType: "json",
						data: JSON.stringify(this.order.shippingAddress)
					})
						.done((response) => {
							if (response && response.success) {
								this.order = response.data?.order || response.data;
								this.loadShippingOptions(this.order?.shippingAddress?.countryCode);
								$('#shipping-address-offcanvas').modal('hide');
							} else {
								this.alertMessages.push("Unable to save shipping address");
								this.alertClass = this.classForSeverity("Error");
							}
						})
						.fail((jq, s, e) => console.error("AJAX error saving shipping address:", s, e));
				},

				cancelShippingEdit() {
					this.loadOrder()
						.then(() => {
							this.loadShippingOptions(this.order?.shippingAddress?.countryCode);
						})
						.always(() => { this.showShipEditor = false; });
				},

				loadCountries: function () {
					return $.ajax({
						url: "/api/countries?requireRegions=true",
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response.success) {
							this.countries = response.data;
							if (!this.order?.shippingAddress?.regionCode)
								this.onCountryChanged();
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading countries:", status, err);
					});
				},

				onCountryChanged: function () {
					const selectedCountry = this.countries.find(c => c.code === this.order?.shippingAddress?.countryCode);
					this.order.shippingAddress.regionCode = (selectedCountry?.regions?.[0]?.code) || "";
					this.loadShippingOptions(this.order.shippingAddress.countryCode);
				},

				onCommentInput: function () {
					this.scheduleCommentSubmit();
				},

				onCsrOverrideChanged: function () {
					const overrideComment = "[CSR Override - Redemption restrictions bypassed]";
					const currentComment = String(this.order.comment || "");

					if (this.form.csrOverride) {
						if (!currentComment.includes(overrideComment))
							this.order.comment = currentComment ? `${currentComment} ${overrideComment}` : overrideComment;
					} else {
						this.order.comment = currentComment
							.replace(overrideComment, "")
							.trim();
					}

					this.scheduleCommentSubmit();
				},

				scheduleCommentSubmit: function () {
					if (this.commentSaveTimerId) {
						clearTimeout(this.commentSaveTimerId);
						this.commentSaveTimerId = null;
					}
					if (this.activeCommentSaveRequest && this.activeCommentSaveRequest.abort) {
						try { this.activeCommentSaveRequest.abort(); } catch (_) { }
						this.activeCommentSaveRequest = null;
					}
					var value = this.form.comment || "";

					this.commentSaveTimerId = setTimeout(this.saveCommentAsync, 300);
				},

				pickMostSevere(messages, fallbackSuccess) {
					let worst = fallbackSuccess ? "Information" : "Error";
					for (const message of (messages || [])) {
						const severity = String(message?.severity || "").toLowerCase();

						if (severity === "error")
							return "Error";
						if (severity === "warning")
							worst = (worst === "Error") ? worst : "Warning";
						if (severity === "information")
							worst = (worst === "Error" || worst === "Warning") ? worst : "Information";
					}
					return worst;
				},

				classForSeverity(severity) {
					switch (severity) {
						case "Error":
							return "alert alert-danger";
						case "Warning":
							return "alert alert-warning";
						default:
							return "alert alert-success";
					}
				},

				applyAlertFromMessages(response, fallbackSuccess = false) {
					const messages = response?.data?.messages || [];
					this.alertMessages = messages.map(m => m?.message).filter(Boolean);
					const severity = this.pickMostSevere(messages, fallbackSuccess);
					this.alertClass = this.classForSeverity(severity);
				},

				saveCommentAsync: function () {
					this.commentSaveTimerId = null;

					this.activeSerialRequest = $.ajax({
						url: "/api/redeem/comment",
						method: "POST",
						contentType: "application/json",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 15000,
						data: JSON.stringify({ memberId: this.memberId, comment: this.order.comment })
					}).done((response) => {
						if (response && response.success !== true) {
							this.applyAlertFromMessages(response, true);
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error saving comment:", status, err);
					}).always(() => {
						this.activeCommentSaveRequest = null;
					});
				},
			},
			mounted: function () {
				this.$nextTick(() => {
					if (this.$refs.table && this.$refs.table.refresh)
						this.$refs.table.refresh();
				});

				this.appLoading = true;

				this.loadOrder()
					.then(() => $.when(this.loadCountries(), this.loadItems()))
					.then(() => this.loadShippingOptions(this.order?.shippingAddress?.countryCode))
					.always(() => {
						this.appLoading = false;
						this.$nextTick(() => {
							if (this.$refs.topAlert && this.$refs.topAlert.focus) this.$refs.topAlert.focus({ preventScroll: true });
						});
					});
			}
		});
	}

	return {
		init: init
	};
})(jQuery, Vue);

App.RedeemPoints.init();
